import { Label } from "../common/GeneralClasses";

export class CommunicationsHubLabels {
  constructor(
    public title = new Label("title", ""),
    public subtitle = new Label("subtitle", ""),
    public statement = new Label("cia_statement", ""),
    public unsubscribeLink = new Label("unsubscribe-link", ""),
    public saveChangesButtonLabel = new Label("button-confirm", ""),
    public okButtonLabel = new Label("button-ok", ""),
    public brandHomepageUrl = new Label("brand-homepage-url", ""),
    public thankYou = new Label("thank-you", ""),
    public error = new Label("error", "")
  ) {}
}
